import { all } from "redux-saga/effects";

//auth


import chatsSaga from "./chats/saga";

export default function* rootSaga() {
  yield all([ chatsSaga()]);
}
